module.exports = __webpack_public_path__ + "static/media/SR105-W1L1-P5 Copy.2f304784.png";